module.exports = __webpack_public_path__ + "media/images/icon-edit-c4d909e1d24d4786e3b5625cd02e2c33.svg";